<script setup>
defineProps({
  displayName: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="agent-tool-status d-flex align-center ga-2">
    <!-- Match assistant avatar position -->
    <div class="agent-tool-status__avatar flex-shrink-0">
      <VProgressCircular
        indeterminate
        size="16"
        width="2"
        color="primary-darker"
      />
    </div>
    <span class="text-body-2 text-medium-emphasis font-italic">
      {{ displayName }}...
    </span>
  </div>
</template>

<style scoped>
.agent-tool-status {
  max-width: fit-content;
  padding: 4px 0;
}

.agent-tool-status__avatar {
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  background: var(--ds-brand-primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
